<template>
  <v-dialog v-model="dialog" width="500">
    <v-card height="100%">
      <v-toolbar :color="$vuetify.theme.dark ? 'primary' : '#07a4ca'" dark>
        <v-card-title class="d-flex justify-content-center text-body-2 text-lg-h6 align-items-center">
          <span>Formulaire Excel</span>
          <v-icon class="ml-2">mdi-file-excel-outline</v-icon>
        </v-card-title>
      </v-toolbar>
      <div style="height: 100%" class="pa-4 d-flex flex-column">
        <v-form ref="formCreationExcel">
          <div class="d-flex flex-column justify-center">
            <v-row class="ma-2">
              <v-autocomplete
                v-model="vendeurFormulaire"
                :rules="[rules.requiredLength]"
                multiple
                outlined
                label="Vendeur"
                :items="sellers"
              >
                <template v-slot:prepend-item>
                  <div>
                    <v-checkbox
                      @click="selectAll('vendeur')"
                      v-model="checkboxModelVendeur"
                      :class="checkboxModelVendeur ? 'checkboxAllClicked' : 'checkboxAll'"
                      class="px-4"
                    >
                      <template v-slot:label>
                        <span
                          :class="checkboxModelVendeur ? 'checkboxAllClickedText' : ''"
                          class="ml-6"
                        >
                          Sélectionnez tous
                        </span>
                      </template>
                    </v-checkbox>
                  </div>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ vendeurFormulaire.length - 1 }} vendeurs)
                  </span>
                </template>
              </v-autocomplete>
              <v-autocomplete
                :rules="[rules.requiredLength]"
                v-model="fournisseurFormulaire"
                multiple
                outlined
                label="Fournisseur"
                :items="suppliers"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ fournisseurFormulaire.length - 1 }} fournisseurs)
                  </span>
                </template>
                <template v-slot:prepend-item>
                  <div>
                    <v-checkbox
                      @click="selectAll('fournisseur')"
                      v-model="checkboxModelFournisseur"
                      :class="checkboxModelFournisseur ? 'checkboxAllClicked' : 'checkboxAll'"
                      class="px-4"
                    >
                      <template v-slot:label>
                        <span
                          :class="checkboxModelFournisseur ? 'checkboxAllClickedText' : ''"
                          class="ml-6"
                        >
                          Sélectionnez tous
                        </span>
                      </template>
                    </v-checkbox>
                  </div>
                </template>
              </v-autocomplete>
              <v-col
                v-if="vendeurFormulaire.length > 0 && fournisseurFormulaire.length > 0"
                cols="12"
                class="pa-0"
              >
                <v-select
                  outlined
                  label="Affichage par :"
                  placeholder="fournisseur"
                  v-model="selectSortedExcel"
                  :items="displayOptions"
                ></v-select>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFormulaireText"
                      :rules="[isRangeDateValide]"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateFormulaire"
                    range
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-btn
              class="white--text"
              :color="$vuetify.theme.dark ? 'primary' : '#07a4ca'"
              @click="createExcel"
            >
              Création Excel
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ExcelExportDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    sellers: {
      type: Array,
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    },
    dateRange: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      vendeurFormulaire: [],
      fournisseurFormulaire: [],
      checkboxModelVendeur: false,
      checkboxModelFournisseur: false,
      dateFormulaire: [],
      dateMenu: false,
      selectSortedExcel: 'Vendeur',
      loading: false,
      rules: {
        requiredLength: value => (value && value.length > 0) || 'Ce champ est obligatoire'
      }
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    displayOptions() {
      const options = ['Vendeur', 'fournisseur'];
      if (this.checkboxModelVendeur && this.checkboxModelFournisseur) {
        options.push('date');
      }
      return options;
    },
    dateFormulaireText() {
      return this.dateFormulaire.join(' ~ ');
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length) {
          this.dateFormulaire = [...newVal];
        }
      }
    }
  },
  methods: {
    selectAll(type) {
      if (type === 'vendeur') {
        if (this.checkboxModelVendeur) {
          this.vendeurFormulaire = [...this.sellers];
        } else {
          this.vendeurFormulaire = [];
        }
      } else if (type === 'fournisseur') {
        if (this.checkboxModelFournisseur) {
          this.fournisseurFormulaire = [...this.suppliers];
        } else {
          this.fournisseurFormulaire = [];
        }
      }
    },
    isRangeDateValide() {
      if (this.dateFormulaire.length > 1) {
        return this.dateFormulaire[0] <= this.dateFormulaire[this.dateFormulaire.length - 1]
          ? true
          : "La date de début doit être inférieure à la date de fin";
      } else if (this.dateFormulaire.length === 1) {
        return true;
      } else {
        return "Champs obligatoire";
      }
    },
    async createExcel() {
      if (!this.$refs.formCreationExcel.validate()) return;
      
      // Ensure there are two dates, duplicating the first one if needed
      let dateRange = [...this.dateFormulaire];
      if (dateRange.length === 1) {
        dateRange.push(dateRange[0]);
      }
      
      this.loading = true;
      this.$emit('loading', true);
      
      try {
        let endpoint, data;
        
        if (this.selectSortedExcel === 'date') {
          endpoint = "createSheetDate";
          data = {
            key: this.selectSortedExcel,
            date: dateRange
          };
        } else {
          endpoint = "createSheetField";
          data = {
            key: this.selectSortedExcel,
            date: dateRange,
            fournisseurs: this.fournisseurFormulaire,
            vendeurs: this.vendeurFormulaire
          };
        }
        
        const response = await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + endpoint + "/",
          method: "POST",
          data: data
        });
        
        if (response.data.result) {
          // Download the file
          const link = document.createElement("a");
          link.href = response.data.result;
          link.download = "rapport_vente.xlsx";
          link.click();
          
          this.dialog = false;
        } else {
          this.$emit('error', "Une erreur est survenue lors de la création du fichier Excel");
        }
      } catch (error) {
        console.error('Error creating Excel:', error);
        this.$emit('error', error.message || "Une erreur est survenue");
      } finally {
        this.loading = false;
        this.$emit('loading', false);
      }
    }
  }
}
</script>

<style scoped>
.checkboxAllClicked {
  background-color: rgba(25, 118, 210, 0.12);
  opacity: 1;
}
.checkboxAllClickedText {
  color: #1976d2 !important;
}
.checkboxAll:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>